<template>
  <div class="c-product-slider bg-white" v-if="slides.length > 0">
    <div class="container-fluid" v-if="headline !== ''">
      <div class="row u-text-center">
        <div class="col c-product-slider__description">
          <h3>{{ headline }}</h3>
        </div>
      </div>
    </div>
    <div :class="['glide', 'js-product-slider' + id]">
      <div class="glide__track" data-glide-el="track">
        <div class="glide__slides" v-if="!hasLinks">
          <router-link
            :to="
              '/' +
                window.toSlug(slide.subtitle) +
                '/' +
                window.toSlug(slide.title)
            "
            class="glide__slide"
            v-for="(slide, index) in slides"
            :key="index"
          >
            <img
              class="c-product-slider__image"
              :class="{
                '-ground': slide.category && slide.category.id === '9',
              }"
              :src="imageurl + slide.image"
            />
            <div class="c-product-slider__category">
              {{ slide.subtitle }}
            </div>
            <div class="c-product-slider__text">
              {{ slide.title }}
            </div>
          </router-link>
        </div>
        <div class="glide__slides" v-else>
          <a
            class="glide__slide"
            v-for="(slide, index) in slides"
            :key="index"
            :href="slide.link"
          >
            <img
              class="c-product-slider__image"
              :src="imageurl + slide.image"
            />
            <div class="c-product-slider__category">
              {{ slide.subtitle }}
            </div>
            <div class="c-product-slider__text" v-html="slide.title"></div>
          </a>
        </div>
        <div
          class="glide__bullets c-product-slider__bullets"
          data-glide-el="controls[nav]"
          v-if="showBullets"
        >
          <button
            aria-label="slider bullet"
            class="glide__bullet"
            :data-glide-dir="'=' + index"
            v-for="(slide, index) in slides"
            :key="'bullet-' + index"
          >
            <div class="glide__bullet-text"></div>
          </button>
        </div>

        <div class="c-product-slider__controls" data-glide-el="controls">
          <div class="c-product-slider__prev" data-glide-dir="<"></div>
          <div class="c-product-slider__next" data-glide-dir=">"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      required: true,
      type: Array,
    },
    headline: {
      required: false,
      type: String,
      default: "",
    },
    id: {
      required: true,
      type: String,
    },
    hasLinks: {
      required: false,
      type: Boolean,
      default: false,
    },
    showBullets: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageurl:
        process.env.VUE_APP_ROOT +
        "index.php?rex_media_type=product_thumbnail&rex_media_file=",
      window: window,
    };
  },
  watch: {
    slides() {
      this.initializeSlider();
    },
  },
  mounted() {
    this.initializeSlider();
  },
  methods: {
    initializeSlider() {
      if (this.slides.length > 0) {
        this.$nextTick(() => {
          new Glide(".js-product-slider" + this.id, {
            type: "carousel",
            autoplay: 2000,
            perView: this.slides.length >= 4 ? 4 : this.slides.length,
            focusAt: "center",
            bound: true,
            breakpoints: {
              800: {
                perView: 2,
              },
              480: {
                perView: 1,
              },
            },
          }).mount();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.c-product-slider {
  margin-top: 80px;
  padding-bottom: 50px;
}
</style>
